import React from 'react';
import { motion } from 'framer-motion';
export function ClientsSection() {
  return <section className="py-24 bg-navy relative border-t border-white/5" data-id="element-34">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-35">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-36">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-37">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 font-heading leading-tight" data-id="element-38">
              Empresas que han <br data-id="element-39" />
              <span className="text-jml-blue" data-id="element-40">confiado en nosotros</span>
            </h2>

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-41">
              <p data-id="element-42">
                Hemos trabajado con empresas como{' '}
                <strong className="text-white" data-id="element-43">
                  Coca-Cola, Ariztía y Panaderías San Camilo
                </strong>
                , una empresa con más de 100 años de trayectoria y más de 60
                sucursales.
              </p>
              <p data-id="element-44">
                También participamos en proyectos mediante licitaciones
                públicas, cumpliendo con exigencias técnicas, administrativas y
                normativas.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-2 gap-4" data-id="element-45">
            <div className="bg-navy-light border border-white/10 rounded-xl p-8 flex items-center justify-center h-36 hover:bg-white/5 transition-colors" data-id="element-46">
              <span className="text-xl font-bold text-gray-400 font-heading tracking-wider" data-id="element-47">
                COCA-COLA
              </span>
            </div>
            <div className="bg-navy-light border border-white/10 rounded-xl p-8 flex items-center justify-center h-36 hover:bg-white/5 transition-colors" data-id="element-48">
              <span className="text-xl font-bold text-gray-400 font-heading tracking-wider" data-id="element-49">
                ARIZTÍA
              </span>
            </div>
            <div className="bg-navy-light border border-white/10 rounded-xl p-8 flex items-center justify-center h-36 hover:bg-white/5 transition-colors" data-id="element-50">
              <span className="text-xl font-bold text-gray-400 font-heading tracking-wider text-center" data-id="element-51">
                PANADERÍAS SAN CAMILO
              </span>
            </div>
            <div className="bg-navy-light border border-white/10 rounded-xl p-8 flex items-center justify-center h-36 hover:bg-white/5 transition-colors" data-id="element-52">
              <span className="text-xl font-bold text-gray-500 font-heading tracking-wider text-center uppercase" data-id="element-53">
                Licitaciones Públicas
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}